var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w250",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_BusinessType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "searchJobType" },
                                on: {
                                  change: function($event) {
                                    return _vm.handleTypeChange(true)
                                  }
                                },
                                model: {
                                  value: _vm.searchConditions.jobType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchConditions,
                                      "jobType",
                                      $$v
                                    )
                                  },
                                  expression: "searchConditions.jobType"
                                }
                              },
                              _vm._l(_vm.types, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w250",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_BusinessModel")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "searchContainerLoadType",
                                  clearable: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleContainerLoadTypeChange(
                                      true
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.searchConditions.containerLoadType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchConditions,
                                      "containerLoadType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "searchConditions.containerLoadType"
                                }
                              },
                              [
                                _vm._l(_vm.containerLoadType.SI, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.searchConditions.jobType === "SI",
                                        expression:
                                          "searchConditions.jobType==='SI'"
                                      }
                                    ],
                                    key: "SI" + index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                _vm._l(_vm.containerLoadType.AE, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.searchConditions.jobType === "AE",
                                        expression:
                                          "searchConditions.jobType==='AE'"
                                      }
                                    ],
                                    key: "AE" + index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                _vm._l(_vm.containerLoadType.AI, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.searchConditions.jobType === "AI",
                                        expression:
                                          "searchConditions.jobType==='AI'"
                                      }
                                    ],
                                    key: "AI" + index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                _vm._l(_vm.containerLoadType.default, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.searchConditions.jobType ===
                                            "SE" ||
                                          _vm.searchConditions.jobType ===
                                            "RE" ||
                                          _vm.searchConditions.jobType === "RI",
                                        expression:
                                          "searchConditions.jobType==='SE'||searchConditions.jobType==='RE'||searchConditions.jobType==='RI'"
                                      }
                                    ],
                                    key: "default" + index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                _vm._l(_vm.containerLoadType.IE, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.searchConditions.jobType === "IE",
                                        expression:
                                          "searchConditions.jobType==='IE'"
                                      }
                                    ],
                                    key: "IE" + index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CustomJobType")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "searchCustomJobType",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_CutomJobType,
                                multiple: true,
                                clearable: false,
                                filterable: "",
                                "method-params": {
                                  type: _vm.searchConditions.jobType,
                                  grade: 0,
                                  active: true
                                },
                                "default-multiple-value":
                                  _vm.searchConditions.customJobType,
                                "tag-value": "code",
                                "tag-name": _vm.isZh ? "name" : "englishName",
                                cache: false,
                                "static-options": _vm.searchCustomJobTypeList,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.searchConditions.customJobType = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OperationOffice")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "searchBranchId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office,
                                multiple: true,
                                clearable: false,
                                filterable: "",
                                "default-multiple-value":
                                  _vm.searchConditions.branchId,
                                "tag-value": "officeId",
                                "tag-name": "code",
                                "filter-tag-names": [
                                  "englishName",
                                  "chineseName",
                                  "code"
                                ],
                                cache: false,
                                "static-options": _vm.officeList,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.searchConditions.branchId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.toQuery }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.popMappingAddDialog }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.popMappingEditFormDialog }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.toBatchDel }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-options": _vm.gridOptions,
                  "side-bar": _vm.sideBarDefs
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "260310",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchData
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowDialogForm,
            title: _vm.dialogTitle,
            width: "880px",
            "custom-class": "automatic-allocation-config-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDialogForm = $event
            }
          }
        },
        [
          _c("div", { staticClass: "details-view" }, [
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "mappingForm",
                    attrs: {
                      inline: true,
                      model: _vm.mappingForm,
                      "label-width": "100px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("div", { staticClass: "section" }, [
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: { "padding-top": "5px" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              this.$t(
                                "CargoMsg.Cargo_MatchingCriteriaSelection"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w320",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_OperationOffice")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "branchId",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office,
                                  multiple: true,
                                  clearable: false,
                                  filterable: "",
                                  "default-multiple-value":
                                    _vm.mappingForm.branchIdList,
                                  "tag-value": "officeId",
                                  "tag-name": "code",
                                  "filter-tag-names": [
                                    "englishName",
                                    "chineseName",
                                    "code"
                                  ],
                                  cache: false,
                                  "static-options": _vm.officeList,
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.mappingForm.branchIdList = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w250",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BusinessType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { no: "type" },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleTypeChange(false)
                                    }
                                  },
                                  model: {
                                    value: _vm.mappingForm.lob,
                                    callback: function($$v) {
                                      _vm.$set(_vm.mappingForm, "lob", $$v)
                                    },
                                    expression: "mappingForm.lob"
                                  }
                                },
                                _vm._l(_vm.types, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w250",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BusinessModel")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "containerLoadType",
                                    clearable: true
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleContainerLoadTypeChange(
                                        false
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.mappingForm.containerLoadType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mappingForm,
                                        "containerLoadType",
                                        $$v
                                      )
                                    },
                                    expression: "mappingForm.containerLoadType"
                                  }
                                },
                                [
                                  _vm._l(_vm.containerLoadType.SI, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mappingForm.lob === "SI",
                                          expression: "mappingForm.lob==='SI'"
                                        }
                                      ],
                                      key: "SI" + index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  _vm._l(_vm.containerLoadType.AE, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mappingForm.lob === "AE",
                                          expression: "mappingForm.lob==='AE'"
                                        }
                                      ],
                                      key: "AE" + index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  _vm._l(_vm.containerLoadType.AI, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mappingForm.lob === "AI",
                                          expression: "mappingForm.lob==='AI'"
                                        }
                                      ],
                                      key: "AI" + index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  _vm._l(
                                    _vm.containerLoadType.default,
                                    function(item, index) {
                                      return _c("el-option", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.mappingForm.lob === "SE" ||
                                              _vm.mappingForm.lob === "RE" ||
                                              _vm.mappingForm.lob === "RI",
                                            expression:
                                              "mappingForm.lob==='SE'||mappingForm.lob==='RE'||mappingForm.lob==='RI'"
                                          }
                                        ],
                                        key: "default" + index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  _vm._l(_vm.containerLoadType.IE, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mappingForm.lob === "IE",
                                          expression: "mappingForm.lob==='IE'"
                                        }
                                      ],
                                      key: "IE" + index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w320",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CustomJobType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customJobType",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CutomJobType,
                                  multiple: true,
                                  clearable: false,
                                  filterable: "",
                                  "method-params": {
                                    type: _vm.mappingForm.lob,
                                    grade: 0,
                                    active: true
                                  },
                                  "default-multiple-value":
                                    _vm.mappingForm.customJobTypeList,
                                  "tag-value": "code",
                                  "tag-name": _vm.isZh ? "name" : "englishName",
                                  cache: false,
                                  "static-options": _vm.customJobTypeList,
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.mappingForm.customJobTypeList = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w500",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_OperateBy")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "opId",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_User,
                                  multiple: true,
                                  clearable: true,
                                  filterable: "",
                                  "method-params": {
                                    category: "role",
                                    shape: "op"
                                  },
                                  "default-multiple-value":
                                    _vm.mappingForm.opIdList,
                                  "tag-value": "userId",
                                  "tag-name": "chineseName",
                                  "filter-tag-names": [
                                    "englishName",
                                    "chineseName",
                                    "userCode"
                                  ],
                                  cache: false,
                                  "static-options": _vm.userList,
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.mappingForm.opIdList = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "section" },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                staticStyle: {
                                  "padding-top": "5px",
                                  "padding-right": "20px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    this.$t(
                                      "CargoMsg.Cargo_AutomaticAllocationRuleConfig"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "enabled" },
                                    model: {
                                      value: _vm.mappingForm.enabled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mappingForm,
                                          "enabled",
                                          $$v
                                        )
                                      },
                                      expression: "mappingForm.enabled"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v(_vm._s(_vm.$t("Message.Open")))
                                    ]),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_AllocationNature"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "allocationNature" },
                                    model: {
                                      value: _vm.mappingForm.allocationNature,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mappingForm,
                                          "allocationNature",
                                          $$v
                                        )
                                      },
                                      expression: "mappingForm.allocationNature"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Message.VirtualAllocation")
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_HblSingleAllocation"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "onlyJoinFlagHBL" },
                                    model: {
                                      value: _vm.mappingForm.onlyJoinFlagHBL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mappingForm,
                                          "onlyJoinFlagHBL",
                                          $$v
                                        )
                                      },
                                      expression: "mappingForm.onlyJoinFlagHBL"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        this.$t(
                                          "CargoMsg.Cargo_OnlyAllocatedToHblSingle"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-card",
                          {
                            attrs: {
                              header: _vm.$t("CargoMsg.Cargo_MasterBill"),
                              shadow: "always"
                            }
                          },
                          [
                            _c("cargo-ag-grid", {
                              attrs: {
                                "show-side-bar": false,
                                "grid-options": _vm.costTable.grid.gridOptions,
                                "column-defs": _vm.dynamicCostColumnDefs,
                                "row-data": _vm.mappingForm.details,
                                "min-height": "200px"
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.costTable.grid.gridApi = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "section" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-textarea-label100",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RemarksInfo")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "remark", type: "textarea" },
                              model: {
                                value: _vm.mappingForm.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.mappingForm, "remark", $$v)
                                },
                                expression: "mappingForm.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini " },
                  on: {
                    click: function($event) {
                      _vm.isShowDialogForm = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }